export default __webpack_public_path__ + "static/media/stride-university.41ecc194.webp";